/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import heroSlider from "imComponents/hero-slider/hero-slider";
import heroImage from "imComponents/hero-image/hero-image";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import button from "components/buttons/buttons";
import cmsContent from "components/cms-content/cms-content";
import footer from "components/footer/footer";
import contactForm from "components/contact-form/contact-form";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import textImgVar from "imComponents/text-img-var/text-img-var";
import accordion from "imComponents/accordion/accordion";
import cardNews from "components/cards/card-news";
import sliderNews from "components/slider-news/slider-news";
import customQuote from "components/custom-quote/custom-quote";
import colTitleText from "components/col-title-text/col-title-text";
import sliderTextOnBg from "components/slider-text-on-bg/slider-text-on-bg";
import cardTextOnBg from "components/cards/card-text-on-bg";
import carouselGallery from "imComponents/carousel-gallery/carousel-gallery";
import cardTextImg from "components/cards/card-text-img";
import sliderTextImg from "components/slider-text-img/slider-text-img";
import listBlock from "components/list-block/list-block";
import boxImage from "components/box-image/box-image";
import textIframe from "components/text-iframe/text-iframe";
import titleBox from "components/title-box/title-box";
import modal from "imComponents/modal/modal";
import menu from "components/menu/menu";
import customAccordion from "components/custom-accordion/custom-accordion";

//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents(){
    if( !document.querySelector("body.wp-admin") ){
        initHeader();
        heroSlider();
    }
    accordion();
    carouselGallery();
    sliderNews();
    sliderTextImg();
    sliderTextOnBg();
    modal();
}
if( document.querySelector("body.wp-admin") ){
    (function($){
        var initBlock = function( $block ) {
            initAllComponents();
        };
        if( window.acf ) {
            window.acf.addAction( 'render_block_preview', initBlock ); 
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
